import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CsrIndicator } from "src/api/client-api/csrStrategy/useGetAllStrategy";
import { getCampaignInProgress } from "src/context/Campaigns/useCampaigns";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { IndicatorListItem } from "./IndicatorListItem";

type IndicatorListProps = {
    indicators: CsrIndicator[];
    onOpenLeverDetails?: (indicator: CsrIndicator) => void;
};
export const IndicatorList = (props: IndicatorListProps) => {
    const { indicators, onOpenLeverDetails } = props;
    const { t } = useTranslation();
    const { campaigns, targetCampaign } = useFoodpilotContext();
    const campaignInProgress = getCampaignInProgress(campaigns);
    const currentCampaignGoalLabel =
        campaignInProgress ?
            t("csr_strategy.page.goal.current_campaign", {
                campaign: campaignInProgress.label,
                defaultValue: "{{campaign}} Goal",
            })
        :   t("settings.csr.form.indicator.fields.shorttermgoal", "Current campaign goal");
    const targetCampaignGoalLabel =
        targetCampaign ?
            t("csr_strategy.page.goal.target_year", {
                targetYear: targetCampaign.year,
                defaultValue: "{{targetYear}} Goal",
            })
        :   t("settings.csr.form.indicator.fields.longtermgoal", "Target campaign goal");

    if (indicators.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                alignItems: "stretch",
                columnGap: 2,
                display: "grid",
                gridAutoRows: "max-content",
                gridTemplateColumns: {
                    xs: "minmax(0, 1fr)",
                    md: "repeat(3, minmax(0, 1fr))",
                },
            }}
        >
            {indicators.map((indicator) => (
                <IndicatorListItem
                    key={indicator.id ?? indicator["@id"]}
                    indicator={indicator}
                    currentCampaignGoalLabel={currentCampaignGoalLabel}
                    targetCampaignGoalLabel={targetCampaignGoalLabel}
                    onOpenLeverDetails={onOpenLeverDetails}
                />
            ))}
        </Box>
    );
};
